import React, {useState} from "react";
import { Button, Checkbox, Control, Field } from "@allxsmith/bestax-bulma";
import ConfirmCollectedModal from "./ConfirmCollectedModal";
import useEditableTableTextAreaCell from "../../../hooks/useEditableTableTextAreaCell";
import useInlineEditButton from "../../../hooks/useInlineEditButton";


export default function ExternalVehicleRow({data, onKeyUnassign, index, onVehicleCollected, onChange, onSave}){
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [editable, setEditable] = useState(false);

    const handleSave = () => {
        onSave(data).then(res => setEditable(false));
    }

    const handleCollect = () => {
        onVehicleCollected(data);
        setConfirmModalOpen(false);
    }

    const handleCheck = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: e.target.checked
            }
        }
        onChange(toUpdate, index)
    }


    return (
        <tr key={data.id}>
            <td>{data.registration}</td>
            <td>{data.make ? data.make.name : ""}</td>
            <td>{data.model ? data.model.name : ""}</td>
            <td>{data.key ? data.key.key_number : ""}</td>
            <td>{data.owner ? data.owner.display_name : ""}</td>
            <td>{data.hire_customer ? data.hire_customer.display_name : ""}</td>
            <td>{data.ready_to_collect}</td>
            {useEditableTableTextAreaCell({
                propName: "vehicle_collection_comments",
                value: data.vehicle_collection_comments,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true
            })}
            <td>
                <Field className="has-addons">
                    <Control>
                      <Checkbox
                        onChange={handleCheck}
                        checked={data.stored_vehicle}
                        name={"stored_vehicle"}
                        disabled={!editable}
                      />
                    </Control>
                    {useInlineEditButton({show: true, onSave: handleSave, disabled: false, setEditable, editable})}
                  </Field>
            </td>
            <td>
                <Button
                    color={"danger"}
                    onClick={() => onKeyUnassign(data)}
                >
                    Unassign Key
                </Button>
            </td>
            {data.ready_to_collect === "READY TO COLLECT" ?
            <td>
                <Button
                    color={"success"}
                    onClick={() => setConfirmModalOpen(true)}
                >
                    COLLECTED
                </Button>
            </td> : <td></td>
            }
            <ConfirmCollectedModal
                open={confirmModalOpen}
                setOpen={setConfirmModalOpen}
                onCollected={handleCollect}
            />
        </tr>
    );

}